export default "__VITE_ASSET__CQVwdyzZ__"